export default {
  // 根据当前数据动态下载提货单 PDF
  downloadPickupPdf: '/ygsjzs/yxcPickupOrder/downloadPickupPdf',
  // 新增提货订单
  insertYxcPickupOrder: '/ygsjzs/yxcPickupOrder/insertYxcPickupOrder',
  // 解析批量新增提货单的车辆导入表格
  parseVehicleImport: '/ygsjzs/yxcPickupOrder/parseVehicleImport',
  // 修改提货订单
  updateYxcPickupOrder: '/ygsjzs/yxcPickupOrder/updateYxcPickupOrder',
  // 审批提货订单
  approvalYxcPickupOrder: '/ygsjzs/yxcPickupOrder/approvalYxcPickupOrder',
  // 删除提货订单
  deleteYxcPickupOrder: '/ygsjzs/yxcPickupOrder/deleteYxcPickupOrder',
  // 查询提货订单详情
  selectYxcPickupOrderByPickupId: '/ygsjzs/yxcPickupOrder/selectYxcPickupOrderByPickupId',
  // 分页查询提货订单列表
  selectYxcPickupOrderByPage: '/ygsjzs/yxcPickupOrder/selectYxcPickupOrderByPage',
  selectYxcPickupOrderByPageV2: '/ygsjzs/yxcPickupOrder/selectYxcPickupOrderByPageV2',
  // 导出
  exportYxcPickupOrder: '/ygsjzs/yxcPickupOrder/exportYxcPickupOrderV2',
  updateYxcPlanPickupOrder: '/ygsjzs/yxcPickupOrder/updateYxcPlanPickupOrder',
  // 修改提货的计划数量
  updateYxcPlanPickupNum: '/ygsjzs/yxcPickupOrder/updateYxcPlanPickupNum',
  // 修改车辆
  updateYxcPlanVehicle: '/ygsjzs/yxcPickupOrder/updateYxcPlanVehicle',
  selectYxcPickupOrderByPickupNum: '/ygsjzs/yxcPickupOrder/selectYxcPickupOrderByPickupNum',
  // 退回云销订单
  bakeYxcPickupOrder: '/ygsjzs/yxcPickupOrder/bakeYxcPickupOrder',
  // 导出发货单
  exportYxcXzFhd: '/ygsjzs/yxcPickupOrder/xzFhd',
  // 修改规格
  updateYxcPlanNewSpecId: '/ygsjzs/yxcPickupOrder/updateYxcPlanNewSpecId'
}
